import classnames from 'classnames'
import PropTypes from 'prop-types'
import { ExternalLinkButton } from 'src/Components'

const HomebotListingsButton = ({
  className,
  listingsUrl,
  children,
  ...restProps
}) => (
  <ExternalLinkButton
    className={classnames(className)}
    data-qa='homebotListingsButton'
    href={listingsUrl}
    {...restProps}
  >
    {children}
  </ExternalLinkButton>
)

HomebotListingsButton.propTypes = {
  className: PropTypes.string,
  listingsUrl: PropTypes.string,
  children: PropTypes.any
}

export default HomebotListingsButton
